import { useMemo } from 'react';
import { useCurrentUser } from './useCurrentUser';

export const useCanEditProject = (project) => {
  const { user } = useCurrentUser();

  const canEdit = useMemo(() => {
    if (!user || !project) return false;
    const {
      is_ops,
      organization_membership: { is_admin, is_active, is_customer_success },
    } = user;

    if (project.is_managed && !is_customer_success) return false;

    if (!is_active) return false;

    if (!!is_ops || is_admin) return true;

    if (project.user_id === user.id) return true;

    return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(project)]);

  return { canEdit };
};
